import lazyLoading from './lazyLoading'

export default {
  name: 'supervisor',
  meta: {
    expanded: false,
    title: 'Supervisor',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },
  children: [
    {
      name: 'SupervisorDashboard',
      path: '/supervisor/dashboard',
      component: lazyLoading('supervisor/dashboard/dashboard'),
      meta: {
        title: 'Dashboard'
      }
    },
    {
      name: 'SupervisorMonitor',
      path: '/supervisor/monitor',
      component: lazyLoading('monitor/google-maps/SupervisorGoogleMapsPage'),
      meta: {
        title: 'Monitor Supervisor'
      }
    },
    {
      name: 'SupervisorSales',
      path: '/supervisor/sales',
      component: lazyLoading('app/supervisor/Main'),
      meta: {
        title: 'Ventas'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('app/supervisor/Sales'),
          meta: {
            title: 'Ventas'
          }
        }
      ]
    },
    {
      name: 'supervisorDriver',
      path: '/supervisor-drivers',
      component: lazyLoading('app/supervisor/Main'),
      meta: {
        title: 'Conductores'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('app/supervisor/DriversList'),
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: ':driverId',
          component: lazyLoading('app/supervisor/DriverView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        }
      ]
    },
    {
      name: 'supervisorCars',
      path: '/supervisor-cars',
      component: lazyLoading('app/supervisor/Main'),
      meta: {
        title: 'Vehículos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('app/supervisor/CarsList'),
          meta: {
            title: 'Vehículos'
          }
        },
        {
          path: ':carId',
          component: lazyLoading('app/supervisor/CarView'),
          props: true,
          meta: {
            title: 'Vehículo'
          }
        }
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/supervisor.js